export enum ConciergeObligationTypes {
  NONE = 'none',
  PARTIAL = 'partial',
  FULL = 'full',
}
